<template>
    <div></div>
</template>

<script>
/**
 * @see https://medium.com/javascript-in-plain-english/many-ways-to-rerender-a-vue-component-660376d94cc1
 */
export default {
    data: () => ({}),

    created() {
        this.trackTimezone();
    },

    mounted() {},

    computed: {},

    methods: {}
}
</script>

<style lang="scss" scoped>
</style>
